import { chuHienTai } from './theo-nganh.ts'

/** Chuỗi của gói nhiều buổi + ví (B5). Tiếng Việt có dấu, câu ngắn, không thuật ngữ kế toán. */
export const G = {
  // Thẻ khách
  cardTitle: 'Gói & ví của khách',
  // ADR-074: tắt "Gói và ví" thì màn khách không nhắc gói / ví (ui-critic v28 BLOCKER).
  cardTitleGon: 'Hồ sơ khách',
  wallet: 'Ví trả trước',
  walletBonus: (tang: string) => `+${tang} tặng`,
  walletEmpty: 'Ví đang trống',
  get packages() {
    return chuHienTai().goiNhieuLan
  },
  noPackage: 'Khách chưa mua gói nào.',
  sessionsLeft: (con: number, tong: number) => `còn ${con}/${tong} buổi`,
  // Mã gói = mã trong tin Zalo "gói sắp hết hạn" (maGoi, @sapa/shared) — quầy đối chiếu khi khách hỏi.
  packageCode: (ma: string) => `mã ${ma}`,
  expiresOn: (ngay: string) => `hạn đến ${ngay}`,
  trangThai: {
    con: '',
    'het-han': 'Hết hạn',
    'het-buoi': 'Hết buổi',
    'da-dong': 'Đã hoàn tiền',
  } as Record<string, string>,
  sellPackage: 'Bán gói',
  topUp: 'Nạp ví',
  history: 'Lịch sử',
  more: 'Việc khác',
  refundPackage: 'Hoàn tiền gói',
  grantSessions: 'Tặng thêm buổi',
  extend: 'Gia hạn',
  refundWallet: 'Hoàn tiền ví',
  opening: 'Nhập số dư cũ',
  cancelOpening: 'Huỷ gói nhập nhầm',
  cancelOpeningTitle: 'Huỷ gói nhập nhầm',
  cancelOpeningBody:
    'Gói này nhập từ sổ cũ và chưa dùng buổi nào. Huỷ thì gói biến khỏi danh sách của khách.',
  cancelOpeningBtn: 'Huỷ gói này',
  openingCancelled: 'Đã huỷ gói nhập nhầm',
  openKhach: 'Gói & ví',
  openKhachGon: 'Xem',
  // Nút trong tờ chi tiết lịch: nói rõ mở ra cái gì (chủ tiệm không hiểu "Gói & ví" là gì — phản ánh 30/09).
  openKhachHoSo: 'Hồ sơ khách',
  openKhachHint: 'Ví trả trước và gói nhiều buổi của khách này.',
  openKhachHoSoHint: 'Ngày sinh, điểm thưởng và các lần khách đã đến.',
  walletExplain:
    'Ví trả trước: khách nạp tiền trước, mỗi lần làm trừ dần. Gói: khách mua trọn nhiều buổi, mỗi lần làm trừ một buổi.',
  back: 'Quay lại',

  // Bán gói
  sellTitle: 'Bán gói cho khách',
  pickPlan: 'Chọn gói',
  noPlan: 'Tiệm chưa có gói nào để bán.',
  noPlanHint: 'Chủ tiệm tạo gói ở Cấu hình → Gói & ví.',
  planLine: (tra: number, tang: number) =>
    tang > 0 ? `${tra} buổi + tặng ${tang}` : `${tra} buổi`,
  planValidity: (ngay: number) => `dùng trong ${ngay} ngày`,
  payMethod: 'Khách trả bằng',
  hinhThuc: {
    cash: 'Tiền mặt',
    transfer: 'Chuyển khoản',
    card: 'Quẹt thẻ',
    mixed: 'Nhiều cách',
  } as Record<string, string>,
  collect: (tien: string) => `Thu ${tien}`,
  pickPlanFirst: 'Chọn gói để thu tiền',
  sold: (ten: string) => `Đã bán gói ${ten}`,

  // Nạp ví
  topUpTitle: 'Nạp tiền vào ví',
  amount: 'Số tiền nạp',
  amountPlaceholder: 'ví dụ 5.000.000',
  bonusPreview: (tang: string) => `Tiệm tặng thêm ${tang}`,
  noBonus: 'Mức này chưa có tiền tặng.',
  bonusNotRefundable: 'Tiền tặng không được hoàn lại.',
  topUpBtn: (tien: string) => `Nạp ${tien}`,
  enterAmount: 'Nhập số tiền để nạp',
  toppedUp: (tien: string) => `Đã nạp ${tien} vào ví`,

  // Hoàn tất lịch
  finishTitle: 'Hoàn tất lịch',
  usePackage: 'Trừ buổi gói',
  payNormal: 'Trả tiền như thường',
  packageOption: (ten: string, con: number, han: string) => `${ten} · còn ${con} buổi · hạn ${han}`,
  alreadyUsed: 'Đã trừ gói',
  payByWallet: 'Trả bằng ví',
  walletHas: (tien: string) => `Ví còn ${tien}`,
  walletPay: (tien: string) => `Trừ ${tien} từ ví`,
  dueCounter: 'Khách trả tại quầy',
  counterPayBy: 'Khách trả bằng',
  // KH-GĐ2 5.1: chia nhiều cách + QR chuyển khoản lúc thu.
  splitOpen: 'Khách trả nhiều cách',
  splitClose: 'Trả một cách',
  splitTitle: 'Khách trả mỗi cách bao nhiêu',
  splitOk: 'Đủ số phải thu.',
  splitShort: (tien: string) => `Còn thiếu ${tien}.`,
  splitOver: (tien: string) => `Thừa ${tien} — bớt lại cho đúng.`,
  splitCollect: (tien: string) => `thu ${tien} nhiều cách`,
  showQr: (tien: string) => `Hiện mã QR chuyển khoản ${tien}`,
  // v0.23.2: tài khoản nhận tiền có thẻ riêng (L7-49). Chủ thấy câu + nút; vai khác (quản lý, lễ tân, KTV tự thu) thấy câu nhờ chủ, không nút.
  // NBSP giữ "mã QR." và "Cấu hình." liền nhau: dòng cuối không còn mỗi chữ "QR." (khổ 320px).
  qrNoAccount: 'Tiệm chưa khai tài khoản nhận tiền nên chưa có mã QR.',
  qrNoAccountBtn: 'Khai tài khoản nhận tiền',
  qrNoAccountAsk: 'Chưa có mã QR. Nhờ chủ tiệm khai tài khoản nhận tiền ở Cấu hình.',
  qrContent: (nd: string) => `Nội dung: ${nd}`,
  collectNow: 'Thu tiền',
  chuaThu: 'Chưa thu',
  notPaidYet: 'Lịch đã làm xong nhưng quầy chưa thu tiền.',
  collectBy: (tien: string, cach: string) => `thu ${tien} ${cach.toLowerCase()}`,
  paidToast: (so: string, tien: string, cach: string) =>
    `Đã thu ${tien} ${cach.toLowerCase()} · hoá đơn ${so}`,
  recordedToast: (so: string) => `Đã ghi hoá đơn ${so} — không thu thêm tiền`,
  walletToast: (so: string, tien: string) => `Đã trừ ví ${tien} · hoá đơn ${so}`,
  lineServices: 'Dịch vụ',
  lineProducts: (n: number) => `Sản phẩm ×${n}`,
  recordOnly: 'ghi hoá đơn',
  removeDiscount: 'Bỏ giảm giá',
  walletBefore: 'Đã trừ ví từ trước',
  addDiscount: 'Giảm giá',
  discountAmount: 'Giảm bao nhiêu',
  discountHint: 'ví dụ 50.000',
  discountTooBig: 'Giảm nhiều hơn số phải trả.',
  // QA 02/10 mục 1: giảm lớn mà hoa hồng tính trên giá gốc thì thợ vẫn nhận đủ — nhắc người bấm, không chặn.
  discountBig: 'Giảm hơn nửa số phải trả — thợ vẫn nhận đủ hoa hồng theo giá gốc.',
  discountLine: 'Giảm giá',
  reasonDiscount: 'ví dụ: khách quen, đền bù chờ lâu',
  // KH-GĐ2 GĐ3: ưu đãi khách mới ở tờ thu tiền
  uuDaiCo: (moTa: string) => `Khách có ưu đãi: ${moTa}`,
  uuDaiGiam: (tien: string) => `Giảm ${tien} cho lần này`,
  uuDaiKhongAp: 'Ưu đãi không áp cho dịch vụ nào đang thu.',
  uuDaiDong: 'Ưu đãi khách mới',
  // C6 (27/10): tờ thu của thợ — thợ không áp ưu đãi (ADR-078), chỉ được báo để nhờ quầy.
  uuDaiNhoQuay: 'Khách có ưu đãi — nhờ quầy tính tiền',
  // KH-GĐ2 6.2.4
  maChuDuyet: (tien: string) => `Chủ tiệm duyệt giảm ${tien} — gõ mã duyệt`,
  maChuDuyetPhu:
    'Mã duyệt giảm giá chủ tiệm đặt ở Cấu hình (không phải mã đăng nhập). Đổi số giảm là phải duyệt lại.',
  dueWallet: 'Trừ ví',
  dueDeposit: 'Trừ tiền cọc',
  dueWalletAll: 'Trừ hết ví',
  dueRestAtCounter: 'Ví không đủ — phần còn lại khách trả tại quầy.',
  walletHasSplit: (that: string, tang: string) => `Ví còn ${that} + ${tang} tặng`,
  finishSessions: (n: number) => `trừ ${n} buổi`,
  finishWallet: (tien: string) => `trừ ví ${tien}`,
  notLoaded: 'Chưa tải được số tiền',
  loadFailed: 'Chưa tải được. Bạn thử lại nhé.',
  finishedWallet: (tien: string) => `Đã hoàn tất lịch · đã trừ ${tien} từ ví`,
  finishBtn: 'Xong',
  finishing: 'Đang lưu…',
  finished: 'Đã hoàn tất lịch',
  noCustomer: 'Lịch này chưa gắn khách nên không trừ gói hay ví được.',

  // Hoàn / tặng / gia hạn / đảo
  refundTitle: 'Hoàn tiền gói',
  refundMax: (tien: string) => `Hoàn tối đa ${tien}`,
  // Gói nhập từ sổ cũ đã dùng buổi: đóng gói = phần còn giữ thành doanh thu, dù không có đồng nào vừa thu.
  refundSoCuDaDung: (n: number) => `Gói này đã dùng ${n} buổi — hoàn lại sẽ tính vào doanh thu.`,
  refundFormula: (daDung: number, giaLe: string) =>
    `Giá đã trả trừ ${daDung} buổi đã dùng × giá lẻ ${giaLe}. Được nhập thấp hơn, không cao hơn.`,
  refundAmount: 'Số tiền trả lại khách',
  reason: 'Lý do (bắt buộc)',
  reasonNeeded: 'Ghi lý do để lưu — chủ tiệm sẽ xem lại.',
  reasonRefund: 'ví dụ: khách chuyển nhà',
  reasonGrant: 'ví dụ: bù buổi làm chưa đạt',
  reasonExtend: 'ví dụ: khách đi công tác 2 tháng',
  reasonWallet: 'ví dụ: khách không dùng nữa',
  reasonReverse: 'ví dụ: trừ nhầm khách',
  reasonOpening: 'ví dụ: chuyển từ sổ tay tháng 9',
  reasonCancel: 'ví dụ: nhập nhầm khách',
  refundPayMethod: 'Trả khách bằng',
  // Ô đã có chữ mờ "ngày/tháng/năm" — gợi ý chỉ còn ví dụ (ui-critic v25).
  dateHint: 'Ví dụ 31/12/2027',
  datePlaceholder: 'ngày/tháng/năm',
  dateWrong: 'Ngày chưa đúng. Gõ ngày/tháng/năm.',
  dateUntil: (ngay: string) => `Đến hết ngày ${ngay}`,
  refundBtn: (tien: string) => `Trả khách ${tien}`,
  refunded: (tien: string) => `Đã hoàn ${tien} — gói đã đóng`,
  grantTitle: 'Tặng thêm buổi',
  grantCount: 'Số buổi tặng',
  grantBtn: (n: number) => `Tặng ${n} buổi`,
  granted: (n: number) => `Đã tặng ${n} buổi`,
  extendTitle: 'Gia hạn gói',
  extendTo: 'Dùng được đến',
  extendMonths: (n: number) => (n === 12 ? '+1 năm' : `+${n} tháng`),
  extendBtn: 'Gia hạn',
  extended: 'Đã gia hạn gói',
  refundWalletTitle: 'Hoàn tiền ví',
  refundWalletBody: (that: string, tang: string) =>
    `Trả khách ${that}. Tiền tặng ${tang} bị huỷ. Ví về 0.`,
  refundWalletBtn: (tien: string) => `Trả khách ${tien}`,
  walletRefunded: (tien: string) => `Đã hoàn ${tien} — ví về 0`,
  historyTitle: 'Lịch sử',
  kind: {
    purchase: 'Mua gói',
    use: 'Dùng buổi',
    grant: 'Tặng buổi',
    extend: 'Gia hạn',
    refund: 'Hoàn tiền',
    reversal: 'Sửa sai',
    opening: 'Số dư cũ',
    topup: 'Nạp ví',
    spend: 'Trừ ví',
  } as Record<string, string>,
  reverse: 'Sửa sai',
  reverseTitle: 'Sửa sai dòng này',
  reverseHint: 'Máy sẽ trả lại đúng số của dòng này. Dòng cũ vẫn giữ để xem lại sau.',
  reversed: 'Đã sửa sai',
  alreadyReversed: 'Đã sửa',
  by: (ai: string) => `bởi ${ai}`,

  // Số dư cũ
  openingTitle: 'Nhập số dư cũ từ sổ tay',
  openingHint: 'Chỉ nhập phần CÒN LẠI của khách. Không tính là tiền thu hôm nay.',
  openingPackage: 'Gói còn lại',
  openingService: 'Dịch vụ của gói',
  openingSessions: 'Số buổi còn',
  // STT 2.3 (ADR-090): giá trị còn lại là cơ sở hoa hồng của thợ ở từng buổi — để trống là thợ mất hoa hồng.
  openingValue: 'Giá trị còn lại (để tính hoa hồng)',
  openingValueGoiY: (n: number, gia: string) => `Gợi ý: ${n} buổi × ${gia}`,
  openingValueGoiYMau: (n: number, gia: string) => `Gợi ý theo gói mẫu của tiệm: ${n} buổi, ${gia}`,
  openingValueGiam:
    'Gói khách mua có giảm giá thì sửa lại theo số tiền khách đã trả cho các buổi còn lại.',
  openingValueThieu: 'Nhập giá trị còn lại để thợ được tính hoa hồng.',
  openingValueLech: (goiY: string) =>
    `Khác nhiều so với gợi ý (${goiY}). Bạn xem lại số có đúng không.`,
  openingValueTran: 'Tối đa 100.000.000đ mỗi lần.',
  // V1: dương nhưng nhỏ hơn số buổi × 1.000đ — thợ chỉ có hoa hồng ở buổi đầu.
  openingValueNho: (n: number, toiThieu: string) =>
    `Giá trị này quá nhỏ cho ${n} buổi (tối thiểu ${toiThieu}) — thợ sẽ không có hoa hồng. ` +
    'Bạn kiểm tra lại số tiền (có thể gõ nhầm đơn vị nghìn đồng), hoặc chọn "Gói tặng".',
  openingGift: 'Gói tặng — không tính hoa hồng',
  openingGiftHint: 'Khách không trả tiền cho các buổi này. Thợ làm buổi tặng không có hoa hồng.',
  openingDaCo: (ngay: string, noiDung: string) =>
    `Khách này đã có số dư cũ nhập ngày ${ngay}: ${noiDung}. Nhập thêm nữa?`,
  openingDaCoKhac: (k: number) => `và ${k} lần khác`,
  openingDaCoGoi: (ten: string, n: number, gia: string) => `${ten} — ${n} buổi, ${gia}`,
  openingDaCoGoiTang: (ten: string, n: number) => `${ten} — ${n} buổi tặng`,
  openingDaCoVi: (that: string, tang: string | null) =>
    tang === null ? `ví ${that}` : `ví ${that} + tặng ${tang}`,
  openingAddMore: 'Nhập thêm',
  openingStop: 'Không nhập nữa',
  giftTag: 'Gói tặng',
  giftNoCommission: 'Gói tặng: buổi này thợ không có hoa hồng.',
  openingExpiry: 'Hạn dùng đến',
  openingWallet: 'Ví còn lại',
  openingCash: 'Tiền khách đã nạp còn lại',
  openingBonus: 'Tiền tặng còn lại',
  openingBtn: 'Lưu số dư cũ',
  openingSaved: 'Đã nhập số dư cũ',

  // Khách
  navCustomer: 'Khách',
  pageCustomer: 'Khách & gói',
  pageCustomerGon: 'Khách',
  searchPhone: 'Tìm khách',
  searchPlaceholder: 'Tên hoặc số điện thoại',
  // KH-GĐ2 4.3: tên không cần dấu, hoặc 3–4 số cuối.
  searchHint: 'Gõ tên (không cần dấu) hoặc 3–4 số cuối.',
  searchRecent: 'Khách vừa đặt hoặc vừa tới',
  visitedOn: (ngay: string) => `Tới\u00A0${ngay}`,
  // Khách mới đặt lịch, chưa tới: nói đúng việc đã xảy ra (không ghi "Tới").
  bookedOn: (ngay: string) => `Đặt\u00A0lịch\u00A0${ngay}`,
  bookNewCustomer: 'Đặt lịch cho khách mới',
  noCustomerFound: 'Chưa có khách nào khớp.',
  noCustomerHint:
    'Khách quen chưa có trong máy? Bấm Thêm khách. Khách mới đặt lịch thì hồ sơ tự tạo.',
  bookForPhone: 'Đặt lịch cho số này',

  // Cấu hình
  tab: 'Gói & ví',
  plansTitle: 'Gói bán cho khách',
  plansHint: 'Khách mua trước nhiều buổi với giá ưu đãi. Mỗi lần làm xong, lễ tân trừ một buổi.',
  addPlan: 'Thêm gói',
  editPlan: 'Sửa gói',
  planName: 'Tên gói',
  get planNamePlaceholder() {
    return chuHienTai().viDuTenGoi
  },
  planService: 'Dịch vụ',
  planPaid: 'Số buổi khách trả tiền',
  planBonus: 'Số buổi tặng',
  planPrice: 'Giá bán cả gói',
  planDays: 'Dùng trong (ngày)',
  planActive: 'Đang bán',
  planSaved: 'Đã lưu gói',
  planSave: 'Lưu gói',
  planOff: 'Ngừng bán',
  perSession: (tien: string) => `≈ ${tien}/buổi`,
  tiersTitle: 'Tặng thêm khi nạp ví',
  tiersHint: 'Ví dụ nạp từ 5.000.000đ tặng 10%. Tối đa 5 mức. Lễ tân không tự gõ phần trăm.',
  tierFrom: 'Nạp từ',
  tierPercent: 'Tặng (%)',
  addTier: 'Thêm mức',
  removeTier: 'Bỏ mức này',
  tiersSave: 'Lưu mức tặng',
  tiersSaved: 'Đã lưu mức tặng',
  reportTitle: 'Tiền gói & ví tháng này',
  collected: 'Tiền đã thu',
  collectedSub: (ban: string, nap: string, hoan: string) =>
    `bán gói ${ban} · nạp ví ${nap} · đã hoàn ${hoan}`,
  /** Các cụm của `collectedSub` / `earnedSub` / `owedSub` cho `CacCum` (dấu "·" không mồ côi — vòng 48). */
  collectedSubCum: (ban: string, nap: string, hoan: string) => [
    `bán\u00A0gói\u00A0${ban}`,
    `nạp\u00A0ví\u00A0${nap}`,
    `đã\u00A0hoàn\u00A0${hoan}`,
  ],
  earned: 'Doanh thu đã làm',
  earnedSub: (goi: string, vi: string) => `buổi gói ${goi} · tiêu từ ví ${vi}`,
  earnedSubCum: (goi: string, vi: string) => [
    `buổi\u00A0gói\u00A0${goi}`,
    `tiêu\u00A0từ\u00A0ví\u00A0${vi}`,
  ],
  owed: 'Còn nợ khách',
  owedSub: (buoi: number, goi: string, that: string) =>
    `${buoi} buổi gói chưa làm (${goi}) · tiền khách nạp ví ${that}`,
  owedSubCum: (buoi: number, goi: string, that: string) => [
    `${buoi}\u00A0buổi gói chưa làm (${goi})`,
    `tiền khách nạp ví\u00A0${that}`,
  ],
  owedBonus: (tang: string) => `Ví còn ${tang} tiền tặng — không phải trả lại khách.`,
  owedExpired: (tien: string) => `Gói đã hết hạn còn ${tien} chưa dùng — không tính là nợ.`,
  moneyLogTitle: 'Nhật ký tiền 60 ngày',
  moneyLogHint: 'Mọi lần hoàn tiền, sửa sai, tặng buổi, gia hạn, nhập số dư cũ, đổi giá gói.',
  moneyLogEmpty: 'Chưa có việc nào.',
  moneyLogMore: 'Xem thêm',
  moneyAction: {
    'package.refund': 'Hoàn tiền gói',
    'package.grant': 'Tặng buổi',
    'package.extend': 'Gia hạn gói',
    'package.opening': 'Nhập gói sổ cũ',
    'package.opening_cancel': 'Huỷ gói nhập nhầm',
    'wallet.refund': 'Hoàn tiền ví',
    'wallet.opening': 'Nhập ví sổ cũ',
    'ledger.reverse': 'Sửa sai',
    'appointment.complete_late': 'Hoàn tất lịch ngày cũ',
    'package_plan.price_change': 'Sửa gói bán',
    'wallet_tier.change': 'Đổi mức tặng ví',
    'ledger.mismatch': 'Sổ lệch — cần kiểm tra',
    'invoice.discount': 'Giảm giá hoá đơn',
    'invoice.void': 'Huỷ hoá đơn',
    'commission_rule.change': 'Đổi mức hoa hồng',
    'payroll.lock': 'Chốt bảng hoa hồng',
    'cash.mismatch': 'Két lệch',
    'stock.adjust': 'Kiểm kê kho',
    'product.price_change': 'Đổi giá bán lẻ',
    'consumption.change': 'Đổi định mức tiêu hao',
    'loyalty_rule.change': 'Đổi quy tắc điểm',
  } as Record<string, string>,
  moneyLogGift: 'Gói tặng — không tính hoa hồng',
  moneyLogBonus: (tien: string) => `tặng ${tien}`,
  byRole: (ai: string) => `bởi ${ai}`,
  owedHint: 'Tiền này chưa phải của tiệm: khách đã trả trước, tiệm còn phải làm hoặc trả lại.',
} as const
